import { type TransactionHash, TRANSACTION_TYPES, EVENT_SUFFIXES } from "@/types";
import { createEventEmitter } from "@/events";

export const CLAIM_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.CLAIM}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface ClaimSuccessPayload {
    transactionHash: TransactionHash;
    claimAmount: number;
}

export interface ClaimEventPayloads extends Record<string, unknown> {
    [CLAIM_EVENTS.SUCCESS]: ClaimSuccessPayload;
}

export const claimEventEmitter = createEventEmitter<ClaimEventPayloads>();
